<template>
  <BaseLayout>
    <div class="container mx-auto">
      <section class="flex-col sm:flex md:flex-col tablet:flex-row">
        <BannerLayout
          :bannerImage="bannerImage"
          :bannerHeaderText="bannerHeaderText"
        />
        <section class="flex-1 px-4 overflow-auto h-screen items-start flex justify-center 2xl:items-center">
          <section
            v-if="step === 1"
            class="flex-1 pl-0 pr-0 xl:pl-20 xl:pr-20 sm:pl-10 sm:pr-10"
          >
            <section class="mt-8">
              <p
                class="md:text-xl2 text-2xl leading-10 font-semibold tracking-tight pb-1"
              >
                Create an account
              </p>
              <p
                class="xl:text-base 3xl:text-lg tracking-tight font-medium text-gray-smoke"
              >
                Share your Email and set up the password
              </p>
              <div class="grid grid-cols-2 sm:grid-cols-2 gap-y-3 md:gap-x-8 gap-x-2 sm:mt-4 mt-3">
                <div class="flex flex-col">
                  <label
                    class="text-gray-smoke font-medium text-sm md:text-lg mb-2 mb-1">
                    First name
                  </label>
                  <input
                    type="text"
                    name="first name"
                    class="text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                    placeholder=""
                    v-model.trim="$v.firstName.$model"
                  />
                  <div v-if="$v.firstName.$error">
                    <span
                      class="text-red-700 text-xs"
                      v-if="!$v.firstName.required"
                    >
                      First Name is required
                    </span>
                    <span class="text-red-700 text-xs" v-if="!$v.firstName.alpha">
                      First Name should be alphabets
                    </span>
                  </div>
                </div>
                <div class="flex flex-col">
                  <label
                    class="text-gray-smoke font-medium text-sm md:text-lg mb-2 mb-1"
                    >Last name</label
                  >
                  <input
                    type="text"
                    name="last name"
                    class="text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                    placeholder=""
                    v-model.trim="$v.lastName.$model"
                  />
                  <div v-if="$v.lastName.$error">
                    <span
                      class="text-red-700 text-xs"
                      v-if="!$v.lastName.required"
                    >
                      Last Name is required
                    </span>
                    <span class="text-red-700 text-xs" v-if="!$v.lastName.alpha">
                      Last Name should be alphabets
                    </span>
                  </div>
                </div>
              </div>
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-y-3 md:gap-x-8 gap-x-2 sm:mt-4 mt-3">
                <div class="flex flex-col">
                  <label
                    class="text-gray-smoke font-medium text-sm md:text-lg mb-2 mb-1"
                    >Email</label
                  >
                  <input
                    type="text"
                    name="email"
                    class="text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                    placeholder=""
                    v-model="$v.email.$model"
                    @blur="onblurEmail"
                  />
                  <div v-if="$v.email.$error">
                    <span class="text-red-700 text-xs" v-if="!$v.email.required">
                      Email is required
                    </span>
                    <span
                      class="text-red-700 text-xs"
                      v-else-if="!$v.email.validEmail"
                    >
                      Email is not valid
                    </span>
                  </div>
                  <span class="text-red-700 text-xs" v-if="isUnique">
                    <!-- This Email is already registered. -->
                    An account already exists for this email address.
                    <router-link :to="{ name: 'Login' }" class="text-green-dark hover:underline">Log in </router-link>
                    or use a different email address to Sign up.
                  </span>
                </div>
                <div class="flex flex-col">
                  <label
                    class="text-gray-smoke font-medium text-sm md:text-lg mb-2 mb-1"
                    >Date of birth</label
                  >
                  <!-- <input
                    type="date"
                    name="bday"
                    max="2022-12-31"
                    class="pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                    placeholder="DD/MM/YY"
                    v-model="$v.dob.$model"
                  /> -->
                  <DropdownDatepicker
                    :dropdownClass="'text-gray-slate w-full pl-3 pr-5 h-10 md:h-12 bg-transparent text-gray-smoke border-1 border-borderColor focus:outline-none rounded-md'"
                    display-format="mdy"
                    v-model="$v.dob.$model"
                    v-bind:required="true"
                    v-bind:min-age="13"
                    :default-date="dob"
                    submit-format="dd-mm-yyyy"
                  ></DropdownDatepicker>
                  <div v-if="$v.dob.$error">
                    <span class="text-red-700 text-xs" v-if="!$v.dob.required">
                      Date of Birth is required
                    </span>
                    <!-- <span
                      class="text-red-700 text-xs"
                      v-else-if="$v.dob.invalidDOB"
                    >
                      Invalid Date
                    </span> -->
                    <!-- <span
                      class="text-red-700 text-xs"
                      v-else-if="!$v.dob.validGreaterDOB"
                    >
                      Age should be greater than 18 years
                    </span> -->
                    <!-- <span
                      class="text-red-700 text-xs"
                      v-else-if="!$v.dob.validLesserDOB"
                    >
                      Age should be lesser than 65 years
                    </span> -->
                  </div>
                </div>
              </div>
              <div class="grid grid-cols-2 sm:grid-cols-2 gap-y-3 md:gap-x-8 gap-x-2 sm:mt-4 mt-3">
                <div class="flex flex-col">
                  <label
                    class="text-gray-smoke font-medium text-sm md:text-lg mb-2 mb-1"
                    >Password</label
                  >
                  <div class="w-full max-w-full relative">
                    <input
                      v-if="showPassword"
                      type="text"
                      class="text-gray-slate w-full pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                      placeholder=""
                      v-model="$v.password.$model"
                    />
                    <input
                      v-else
                      type="password"
                      placeholder=""
                      class="text-gray-slate w-full pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                      v-model="$v.password.$model"
                    />
                    <div
                      class="inline absolute eye-control"
                      v-if="$v.password.required"
                    >
                      <span
                        class="icon text-gray-smoke cursor-pointer"
                        @click="toggleShow"
                      >
                        <i
                          class="text-xl fa"
                          :class="{
                            'fa-eye-slash': !showPassword,
                            'fa-eye': showPassword,
                          }"
                        ></i>
                      </span>
                    </div>
                  </div>
                  <div v-if="$v.password.$error" class="mt-1">
                    <p class="text-red-700 text-xs" v-if="!$v.password.required">
                      Password is required
                    </p>
                    <p
                      class="text-red-700 text-xs"
                      v-else-if="!$v.password.minLength"
                    >
                      Password minlength is 8
                    </p>
                    <p
                      class="text-red-700 text-xs"
                      v-else-if="!$v.password.password"
                    >
                      Password should contain at least 1 character & 1
                      number.
                    </p>
                  </div>
                </div>
                <div class="flex flex-col">
                  <label
                    class="text-gray-smoke font-medium text-sm md:text-lg mb-2 mb-1"
                    >Confirm Password</label
                  >
                  <div class="w-full relative">
                    <input
                      v-if="showConfirmPassword"
                      type="text"
                      class="text-gray-slate w-full pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                      placeholder=""
                      v-model="$v.confirmation.$model"
                    />
                    <input
                      v-else
                      type="password"
                      placeholder=""
                      class="text-gray-slate w-full pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                      v-model="$v.confirmation.$model"
                    />
                    <div
                      class="inline absolute eye-control bg-white"
                      v-if="$v.confirmation.required"
                    >
                      <span
                        class="icon text-gray-smoke cursor-pointer"
                        @click="toggleShowConfirm"
                      >
                        <i
                          class="text-xl fa"
                          :class="{
                            'fa-eye-slash': !showConfirmPassword,
                            'fa-eye': showConfirmPassword,
                          }"
                        ></i>
                      </span>
                    </div>
                  </div>
                  <div v-if="$v.confirmation.$error">
                    <span
                      class="text-red-700 text-xs"
                      v-if="!$v.confirmation.sameAsPassword"
                    >
                      Confirm Password is not same as Password
                    </span>
                  </div>
                </div>
              </div>
              <div class="flex flex-col items-center mt-4 3xl:mt-8">
                <div class="flex items-center">
                  <div class="mt">
                    <input
                      type="checkbox"
                      name="terms"
                      class="h-6 w-6 mt-1 cursor-pointer"
                      v-model="$v.consent.$model"
                      :class="{ 'border-red-700': $v.consent.$error }"
                    />
                  </div>
                  <div
                    class="flex tablet:text-xs text-sm xl:text-lg 3xl:text-xl"
                  >
                    <p class="ml-2 font-medium text-gray-smoke">I Agree to the</p>
                    <a
                      :href="VUE_APP_APP_URL + 'terms-of-use'"
                      target="_blank"
                      class="ml-1 font-medium text-black-600 hover:underline"
                    >
                      Terms & Conditions
                    </a>
                  </div>
                </div>
                <div class="flex items-start" v-if="$v.consent.$error">
                  <small class="text-red-700" v-if="!$v.consent.required">
                    Please accept
                  </small>
                </div>
                <section class="mt-4 w-64 3xl:w-74"
                >
                  <button
                    class="rounded-lg w-full bg-green-light h-12 px-6 font-semibold lg:text-sm xl:text-base 3xl:text-lg text-white focus:outline-none"
                    @click.prevent="handleRegister"
                  >
                    Create account
                  </button>
                </section>
                <div class="flex 3xl:mt-4 items-center justify-center md:justify-end text-sm 3xl:text-lg">
                  <p class="text-gray-smoke">Have an account?</p>
                  <router-link :to="{ name: 'Login' }" class="ml-1 hover:underline">
                    Log in
                  </router-link>
                </div>
                <p class="font-semibold 3xl:my-5 my-2">OR</p>
                <GoogleLogin @onLogin="onGoogleLogin" />
              </div>
            </section>
          </section>

          <section
            v-if="step === 2"
            class="flex-1 pl-0 pr-0 xl:pl-20 xl:pr-20 sm:pl-10 sm:pr-10"
          >
            <section
              class="lg:mt-20 mt-8"
            >
              <p
                class="text-3xl 3xl:text-4xl md:text-3xl font-semibold tracking-tight pb-3"
              >
                Where are you located?
              </p>
              <p
                class="tablet:text-sm xl:text-base 2xl:text-lg 3xl:text-xl font-medium text-gray-smoke pb-6"
              >
                We need to know your time-zone to show you correct class times
              </p>
              <p
                class="tablet:text-sm xl:text-base 2xl:text-lg 3xl:text-xl font-medium text-gray-smoke"
              >
                Select your timezone
              </p>
              <!-- <select
                name="select"
                id="select"
                class="px-5 mt-4 w-full tablet:text-sm xl:text-base 2xl:text-lg 3xl:text-xl py-4 ring-1 bg-white ring-gray-400 focus:outline-none rounded-md appearance-none text-gray-light"
                v-model="currentTimeZone"
                @change="changeTimezone($event)"
              >
                <option v-for="(t, i) in timezones" :key="i" :value="t.id">
                  {{ t.display_name }}
                </option>
              </select> -->
              <model-list-select
                :list="timezones"
                v-model="currentTimeZone"
                option-value="id"
                option-text="display_name"
                placeholder="select item"
                class="w-full"
              >
              </model-list-select>
              <div
                class="flex justify-between mt-6 tablet:text-sm xl:text-base 2xl:text-lg 3xl:text-xl"
              >
                <button
                  class="h-12 px-6 rounded-lg font-semibold lg:max-w-74 2xl:max-w-85 3xl:max-w-92 w-full focus:outline-none border-1 border-borderColor"
                  @click.prevent="skipTimeZone"
                >
                  Skip
                </button>
                <button
                  class="h-12 px-6 ml-4 rounded-lg font-semibold bg-green-light lg:max-w-74 2xl:max-w-85 3xl:max-w-92 w-full text-white ring-1 ring-green-light focus:outline-none"
                  @click.prevent="addTimeZone"
                >
                  Continue
                </button>
              </div>
            </section>
          </section>

          <section
            v-if="step === 3"
            class="flex-1 pl-0 pr-0 xl:pl-20 xl:pr-20 sm:pl-10 sm:pr-10"
          >
            <section class="lg:mt-20 mt-8">
              <p
                class="text-2xl xl:text-2xl 2xl:text-3xl 3xl:text-4xl tablet:text-xl md:text-3xl font-semibold tracking-tight pb-3 3xl:pb-5"
              >
                Do you want to attend fitness classes or train?
              </p>
              <p
                class="text-base xl:text-lg 3xl:text-xl font-medium text-gray-smoke pb-6"
              >
                Choose the preferred title from below
              </p>

              <div
                class="flex mt-11 text-base 3xl:text-3xl leading-8 h-32 lg:h-36 xl:h-40 2xl:h-44 3xl:h-48 4xl:h-52"
              >
              <button
                  class=" flex items-center font-semibold justify-center w-1/2 lg:w-64 xl:w-72 3xl:w-80 4xl:w-96 shadow-md rounded-2xl hover:shadow-lg focus:outline-none"
                  :class="{ 'ring-1 ring-green-light': userType === 1 }"
                  @click.prevent="userType = 1"
                >
                  Attendee
                </button>
                <button
                  class="ml-4 flex items-center font-semibold justify-center w-1/2 lg:w-64 xl:w-72 3xl:w-80 4xl:w-96 shadow-md rounded-2xl 2xl:ml-6 3xl:ml-8 hover:shadow-lg focus:outline-none"
                  :class="{ 'ring-1 ring-green-light': userType === 2 }"
                  @click.prevent="userType = 2"
                >
                  Trainer/Attendee
                </button>
                
                
              </div>
              <div class="flex mt-10 text-lg 3xl:text-2xl justify-end">
                <button
                  class="h-12 px-6 rounded-lg font-semibold bg-green-light lg:max-w-74 2xl:max-w-85 3xl:max-w-92 w-full text-white ring-1 ring-green-light focus:outline-none"
                  @click.prevent="signUpComplete"
                >
                  Continue
                </button>
                <!-- <button
                  class="rounded-lg font-semibold :py-3 xl:py-4 2xl:py-5 lg:max-w-74 2xl:max-w-85 3xl:max-w-92 w-full ml-4 focus:outline-none border-1 border-borderColor"
                  @click.prevent="skipSignUpAsTrainer"
                >
                  Skip
                </button> -->
              </div>
            </section>
          </section>
        </section>
      </section>
    </div>
  </BaseLayout>
</template>

<script>
import BaseLayout from "@/components/layouts/BaseLayout";
import BannerLayout from "@/components/layouts/BannerLayout.vue";
import GoogleLogin from "@/components/google-login/GoogleLogin";
import { mapActions, mapGetters } from "vuex";
// import moment from "moment";
import store from "@/store";
import { required, sameAs, minLength, alpha } from "vuelidate/lib/validators";
import DropdownDatepicker from "@/components/vue-dropdown-datepicker/dropdown-datepicker";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import axios from "axios";

export default {
  name: "Signup",
  components: {
    BaseLayout,
    BannerLayout,
    GoogleLogin,
    ModelListSelect,
    DropdownDatepicker
  },
  data() {
    return {
      step: 1,
      showPassword: false,
      showConfirmPassword: false,
      bannerImage: "banner-image.webp",
      bannerHeaderText: "Think it's too late to get fit?",
      email: null,
      password: null,
      confirmation: null,
      consent: "",
      firstName: null,
      lastName: null,
      dob: "",
      firebase_token: null,
      LOADING: true,
      date: "",
      userType: 1,
      currentTimeZone: null,
      timezoneSkipped: false,
      timezones: [],
      isUnique: false,
    };
  },
  validations: {
    email: {
      required,
      validEmail(email) {
        var regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (regex.test(email)) {
          return true;
        } else {
          return false;
        }
      },
    },
    password: {
      required,
      validPassword(password) {
        var regex = /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/;
        if (regex.test(password)) {
          return true;
        } else {
          return false;
        }
      },
      minLength: minLength(8),
    },
    dob: {
      required,
      // validGreaterDOB(dob) {
      //   const years = moment().diff(moment(dob), "years");
      //   if (years >= 18) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // },
      // validLesserDOB(dob) {
      //   const years = moment().diff(moment(dob), "years");
      //   if (years <= 65) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // },
      // invalidDOB(dob) {
      //   const years = moment().diff(moment(dob), "years");
      //   if (years >= 100 || years <= 0) {
      //     return false;
      //   } else {
      //     return true;
      //   }
      // },
    },
    confirmation: {
      required,
      sameAsPassword: sameAs("password"),
    },
    userType: {
      required,
    },
    consent: {
      sameAs: sameAs(() => true),
    },
    firstName: {
      required,
      alpha,
    },
    lastName: {
      required,
      alpha,
    },
  },
  computed: {
    ...mapGetters(["getTimezoneDetails"]),
  },
  methods: {
    ...mapActions([
      "register",
      "resendVerificationEmail",
      "findGuestUser",
      "userCompleteSignup",
      "timezone",
      // "postAccountValidate",
    ]),

    onGoogleLogin(user) {
      if (user && user.user_type == this.TRAINER) {
        this.$router.push({ name: "dashboard" });
      } else {
        this.$router.push({ name: "Newhome" });
      }
    },

    handleRegister() {
      this.$v.$touch();
      if (this.$v.email.$error) {
        return false;
      }
      if (this.isUnique) {
        return false;
      }
      if (this.$v.password.$error) {
        return false;
      }
      if (this.$v.confirmation.$error) {
        return false;
      }
      if (this.$v.userType.$error) {
        return false;
      }
      if (this.$v.consent.$error) {
        return false;
      }
      if (this.$v.$invalid) {
        console.log("invalid");
      } else {
        this.step++;
      }
    },
    // changeTimezone(event) {
    //   this.currentTimeZone = event.target.value;
    // },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleShowConfirm() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    skipTimeZone() {
      this.timezoneSkipped = true;
      this.step++;
    },
    addTimeZone() {
      this.step++;
    },
    async skipSignUpAsTrainer() {
      this.userType = 1;
      await this.signUpComplete();
    },

    async signUpComplete() {
      const data = {
        email: this.email,
        password: this.password,
        password_confirmation: this.confirmation,
        user_type: this.userType,
        consent: this.consent,
        f_name: this.firstName,
        l_name: this.lastName,
        dob: this.dob,
        gender: "",
        interests: "",
        firebase_token: this.firebase_token,
        timezone: this.currentTimeZone, // this.timezoneSkipped === false ? this.currentTimeZone : null,
      };
      store.commit("setIsLoading", true);
      this.register(data).then(() => {
        if (this.userType === 1) this.$router.push({ name: "Newhome" });
        else if (this.userType === 2) this.$router.push({ name: "Register" });
      });
      store.commit("setIsLoading", false);
    },

    async onblurEmail() {
      const data = {
        email: this.email,
      };
      if (this.email) {
        // await this.postAccountValidate(data)
        await axios
          .post("account-validate", data)
          .then(
            (res) =>
              (this.isUnique =
                res && res.data && res.data.data && res.data.data.isExist)
          )
          .catch((e) => (this.isUnique = true));
      }
    },
  },
  async created() {
    await this.timezone();
    this.timezones = this.getTimezoneDetails;
    let timezoneObj =
      this.getTimezoneDetails &&
      this.getTimezoneDetails.find((o) => o.name === this.getTimeZone());
    this.currentTimeZone = timezoneObj && timezoneObj.id;
  },
};
</script>

<style>
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: '';
  background: url("../assets/img/select-chevron.png");
  background-repeat: no-repeat;
  background-position: right 6px center;
}
.maxWidth95{
  max-width: 95px;
}
::placeholder {
  color: #6b7280;
}
.eye-control {
  right: 5%;
  top: 10px;
}
@keyframes transitionFade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.animate-slide-sections {
  animation-name: transitionFade;
  animation-fill-mode: forwards;
  animation-duration: 500ms;
  animation-timing-function: ease-in-out;
}
input[type="checkbox"] {
  accent-color: #99c355;
}
</style>